export default {
    canceled: 'Annulée',
    completed: 'Complétée',
    confirmed: 'Confirmée',
    noShow: 'No show',
    uncompleted: 'Non complétée',
};
